import dayjs from "dayjs";

export const now = () => {
	return dayjs().valueOf();
};

export function moment(value, format) {
	return dayjs.unix(value).format(format);
}
